export var StatusVariant;
(function (StatusVariant) {
    StatusVariant["SUCCESS"] = "SUCCESS";
    StatusVariant["ERROR"] = "ERROR";
    StatusVariant["WARNING"] = "WARNING";
    StatusVariant["INFO"] = "INFO";
})(StatusVariant || (StatusVariant = {}));
